import gql from "graphql-tag";

export const nonRecursiveFolderContainerElementFragment = gql`
  fragment NonRecursiveFolderContainerElementFragment on FolderContainerElement {
    ... on FolderContainerFolderElement {
      content {
        ...ContainerFragment
        type
      }
    }
    ... on FolderContainerKurssloeyfeElement {
      content {
        ...ContainerFragment
        elements {
          ... on KurssloeyfeContainerArticleElement {
            referencedContent
            status
          }
          ... on KurssloeyfeContainerMultipleChoiceElement {
            referencedContent
            status
          }
        }
      }
    }
    ... on FolderContainerArticleElement {
      referencedContent
      status
    }
    ... on FolderContainerMultipleChoiceElement {
      referencedContent
      status
    }
  }
`;

export const folderContainerWithoutFolderElementFragment = gql`
  fragment FolderContainerWithoutFolderElementFragment on FolderContainerElement {
    ... on FolderContainerKurssloeyfeElement {
      content {
        ...ContainerFragment
        elements {
          ... on KurssloeyfeContainerArticleElement {
            referencedContent
            status
          }
          ... on KurssloeyfeContainerMultipleChoiceElement {
            referencedContent
            status
          }
        }
      }
    }
    ... on FolderContainerArticleElement {
      referencedContent
      status
    }
    ... on FolderContainerMultipleChoiceElement {
      referencedContent
      status
    }
  }
`;

export const containerFragment = gql`
  fragment ContainerFragment on Container {
    title
    referencedContentId
    contentList {
      contentId
      status
    }
  }
`;

export const studyProgrammeWithContainerContextsLightFragment = gql`
  fragment StudyProgrammeWithContainerContextsLightFragment on GetExamSyllabusContainerContextsPayloadLight {
    studyProgrammesWithContainers {
      studyProgrammeContainer {
        title
        status
        referencedContentId
      }
    }
  }
`;

export const studyProgrammeWithContainerContextsFragment = gql`
  fragment StudyProgrammeWithContainerContextsFragment on GetExamSyllabusContainerContextsPayload {
    studyProgrammesWithContainers {
      studyProgrammeContainer {
        status
        title
        referencedContentId
        elements {
          ... on StudyProgrammeContainerFolderElement {
            content {
              ...ContainerFragment
              type
              elements {
                ... on FolderContainerFolderElement {
                  content {
                    ...ContainerFragment
                    type
                    elements {
                      ... on FolderContainerFolderElement {
                        content {
                          ...ContainerFragment
                          type
                          elements {
                            ...NonRecursiveFolderContainerElementFragment
                          }
                        }
                      }
                      ...FolderContainerWithoutFolderElementFragment
                    }
                  }
                }
                ...FolderContainerWithoutFolderElementFragment
              }
            }
          }
          ... on StudyProgrammeContainerExamSyllabusElement {
            content {
              ...ContainerFragment
              elements {
                ... on ExamSyllabusContainerFolderElement {
                  content {
                    ...ContainerFragment
                    type
                    elements {
                      ... on FolderContainerFolderElement {
                        content {
                          ...ContainerFragment
                          type
                          elements {
                            ... on FolderContainerFolderElement {
                              content {
                                ...ContainerFragment
                                type
                                elements {
                                  ...NonRecursiveFolderContainerElementFragment
                                }
                              }
                            }
                            ...FolderContainerWithoutFolderElementFragment
                          }
                        }
                      }
                      ...FolderContainerWithoutFolderElementFragment
                    }
                  }
                }
              }
            }
          }
        }
      }
      examSyllabusContainerContexts {
        path
        referencedContentId
      }
      folderContainerContexts {
        path
        referencedContentId
      }
    }
  }
  ${nonRecursiveFolderContainerElementFragment}
  ${folderContainerWithoutFolderElementFragment}
  ${containerFragment}
`;
